var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.list),function(event){return _c('div',[(event.type === 'bang')?_c('BangListItem',{attrs:{"bang":event}}):_c('EventListItem',{attrs:{"sticky":event}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }